import {ClaStorage} from "../../model/events";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {Storage} from "@ionic/storage";

@Injectable()
export class SecurityStorageService {

  constructor(public storage: Storage) {}

  public getSecurityToken() {
    return this.storage.get(ClaStorage.APP_LOGIN_TOKEN)
      .then(
        data => { return data },
        error => {
        }
      );
  }
  public getSecurityTokenAsObservable(): Observable<any> {
    return Observable.fromPromise(this.getSecurityToken());
  }
}



// WEBPACK FOOTER //
// ./src/providers/security-storage/security-storage-service.ts